import React, { useEffect, useRef, useState } from "react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import CheckoutForm from "./CheckoutForm";
import axiosInstance from "../../../../../axiosInstance";

const stripePromise = loadStripe(
  process.env.REACT_APP_STRIPE_PUBLIC_KEY as string
);

interface StripeCheckoutModalProps {
  isOpen: boolean;
  onClose: () => void;
  line_items: {
    product_id: string;
    quantity: number;
  }[];
}

const StripeCheckoutModal: React.FC<StripeCheckoutModalProps> = ({
  isOpen,
  onClose,
  line_items,
}) => {
  const [clientSecret, setClientSecret] = useState<string | null>(null);
  const [amount, setAmount] = useState<number | 0>(0);
const hasFetchedRef = useRef(false);


 


useEffect(() => {
  if (!isOpen) {
    // Reset ref when modal closes so next open can fetch again
    hasFetchedRef.current = false;
    return;
  }

  if (line_items.length === 0 || hasFetchedRef.current) return;

  hasFetchedRef.current = true; // mark as fetched for this open

  const fetchStripeAndOrder = async () => {
    try {
      const stripeRes = await axiosInstance.post("/payments/setup/customers");
      console.log("Stripe setup:", stripeRes.data.data);

      const orderRes = await axiosInstance.post("/orders", { line_items });
      setClientSecret(orderRes?.data?.data?.client_secret);
      setAmount(orderRes?.data?.data?.order_details?.amount);
    } catch (err) {
      console.error("Error fetching Stripe/order:", err);
      setClientSecret(null);
    }
  };

  fetchStripeAndOrder();
}, [isOpen, line_items]);


  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <button className="modal-close" onClick={onClose}>
          ×
        </button>

        {!clientSecret ? (
          <div style={{textAlign:"center"}}>Loading payment...</div>
        ) : (
          <Elements stripe={stripePromise} options={{ clientSecret }}>
            <CheckoutForm amount={amount} onClose={onClose} />
          </Elements>
        )}
      </div>
    </div>
  );
};

export default StripeCheckoutModal;
